import type { FC } from 'react';
import { useContext, useEffect, useState } from 'react';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';
import { Modal } from '@cognite/cogs-core-v11/components/modal/modal.tsx';

import { ModelDetails } from '../../../../../3d/model-details/model-details';
import type { ModelAndRevision3D } from '../../../../../3d/types';

import * as S from './elements';
import { getSelectModelDialogueContext } from './select-model-dialogue.context';

export interface SelectModelDialogueProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (revision: ModelAndRevision3D) => void;
}

export const SelectModelDialogue: FC<SelectModelDialogueProps> = ({
  visible,
  onClose,
  onSelect,
}): JSX.Element => {
  const { use3dModelList } = useContext(getSelectModelDialogueContext());
  const { data, hasNextPage, fetchNextPage } = use3dModelList();

  useEffect(() => {
    if (hasNextPage && fetchNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage]);

  const [selectedModel, setSelectedModel] = useState<ModelAndRevision3D>();

  const renderFooter = () => {
    return (
      <Flex direction="column" gap={8}>
        <Button
          onClick={() => onSelect(selectedModel!)}
          disabled={!selectedModel}
        >
          Select
        </Button>
      </Flex>
    );
  };

  return (
    <Modal
      visible={visible}
      size="medium"
      hideFooter
      title="Select 3d Model"
      onCancel={() => onClose()}
    >
      <S.Container>
        <Flex direction="column" gap={16}>
          {data?.map((revision) => (
            <S.ModelContainer
              key={revision.revisionId}
              selected={selectedModel?.revisionId === revision.revisionId}
            >
              <ModelDetails
                {...revision}
                onClick={() => setSelectedModel(revision)}
              />
            </S.ModelContainer>
          ))}
        </Flex>
      </S.Container>
      {renderFooter()}
    </Modal>
  );
};
